import { getDatabase, onValue, ref, remove, set } from 'firebase/database';
import { useEffect, useState } from 'react'
import { IdleTimerProvider } from 'react-idle-timer';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import FormAcc from '../pages/auth/verif/Acc/Form';
import Home from '../pages/auth/verif/Home';
import Kelengkapan from '../pages/auth/verif/Kelengkapan';
import DetailAdendum from '../pages/auth/verif/kontrak/adendum/Detail';
import DetailKontrak from '../pages/auth/verif/kontrak/Detail';
import Kontrak, { DataKontrak } from '../pages/auth/verif/kontrak/Index';
import NavVr from '../pages/auth/verif/Nav';
import FormSpm from '../pages/auth/verif/Permintaan/Form';
import Spm, { DataSpm } from '../pages/auth/verif/Permintaan/Index';
import ProsesSp2d, { DataProsesSp2d } from '../pages/auth/verif/ProsesSp2d/Index';
import Selesai from '../pages/auth/verif/Selesai';
import { AuthStore, NotifStore } from '../store/UserStore';
import { CustomDescrypt } from '../utils/MyEncryption';

const Verifikator = props => {
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const location = useLocation();
    const [isVerifikator, setIsVerifikator] = useState(false)
    const logOut = AuthStore((state) => state.logOut);

    // const db = firebaseDB
    const db = getDatabase()

    useEffect(() => {
        console.log(location.pathname);
        if (location.pathname !== '/verif/spm/periksa-acc') {
            set(ref(db, 'verifikasi/' + decryptedUser.nip), {
                nama: decryptedUser.nama,
                no_spm: '-',
                opd: '-',
                status: "Sibuk"
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    useEffect(() => {
        if (encryptUser === null || encryptUser === undefined) {
            navigate("/login", { replace: true });
        }
        else {
            if (decryptedUser.user === null) {
                navigate("/login", { replace: true });
            }
            else {
                if (decryptedUser.role !== 'Verifikator') {
                    setIsVerifikator(false)
                    navigate("/login", { replace: true });
                }
                else {
                    setIsVerifikator(true)
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [encryptUser, location, decryptedUser]);

    const permintaan = ref(db, 'permintaan');
    const addPemberitahuan = NotifStore((state) => state.addPemberitahuan)

    useEffect(() => {
        onValue(permintaan, (snapshot) => { // monitor firebase
            let juduls = ""
            let nilai = ""
            console.log(snapshot);
            const dataz = snapshot.val();
            const data = dataz.permintaan;
            if (data !== null) {
                juduls = handleLabel(data)
                nilai = data.anggaran.replaceAll(".", "")

                addPemberitahuan({
                    judul: juduls,
                    anggaran: rP(nilai),
                    nm_opd: data.nm_opd,
                    jenis: data.jenis + " " + data.jenis_ls
                }) // add notif ke store
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permintaan !== null])

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    const handleLabel = (params) => {
        let label = "";

        switch (params.progres) {
            case 0:
                label = "Permintaan Baru";
                break;
            case 1:
                label = "Permintaan diperbarui";
                break;
            default:
                label = "-";
                break;
        }
        console.log(label);

        return label;
    }

    const handleLogOut = () => {
        logOut();
        navigate("/", { replace: true });
        remove(ref(db, "verifikasi/" + decryptedUser.nip))
    }

    const onIdle = () => {
        // Close Modal Prompt
        // Do some idle action like log out your user
        console.log('on idle');
        handleLogOut();
    }

    if (isVerifikator) {
        // console.log("verifikator true");
        return (
            <IdleTimerProvider
                timeout={1000 * 60 * 60}
                // onPrompt={onPrompt}
                onIdle={onIdle}
            // onActive={onActive}
            // onAction={onAction}
            >
                {/* {props.component} */}
                <NavVr child={
                    <Routes>
                        <Route exact path='' element={<Home />} />
                        <Route exact path='spm' element={<Spm />}>
                            <Route exact path='' element={<DataSpm />} />
                            <Route exact path='periksa' element={<FormSpm />} />
                            <Route exact path='periksa-acc' element={<FormAcc />} />
                        </Route>
                        {/* <Route exact path='acc' element={<Acc />} >
                            <Route exact path='' element={<DataAcc />} />
                            <Route exact path='periksa' element={<FormAcc />} />
                        </Route> */}
                        <Route exact path='proses_sp2d' element={<ProsesSp2d />} >
                            <Route exact path='' element={<DataProsesSp2d />} />
                            <Route exact path='periksa' element={<FormAcc />} />
                        </Route>
                        {/* <Route exact path='sp2d_diserahkan' element={<Sp2dDiserahkan />} >
                            <Route exact path='' element={<DataSp2dDiserahkan />} />
                        </Route> */}
                        <Route exact path='selesai' element={<Selesai />} />
                        <Route exact path='kontrak' element={<Kontrak />}>
                            <Route exact path='' element={<DataKontrak />} />
                            <Route exact path='detail' element={<DetailKontrak />} />
                            <Route exact path='adendum-detail' element={<DetailAdendum />} />
                        </Route>
                        <Route exact path='kelengkapan' element={<Kelengkapan />} />
                    </Routes>
                } onLogOut={handleLogOut} setMode={props.setMode} mode={props.mode} />
            </IdleTimerProvider>
        )
    }
}

export default Verifikator